/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type TradeOnboardingCoachmarkConditionalLoader_item$ref = any;
export type TradeOnboardingCoachmarkConditionalLoader_item = {
    readonly serviceId: string | null;
    readonly " $refType": TradeOnboardingCoachmarkConditionalLoader_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TradeOnboardingCoachmarkConditionalLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'b85597d13658b133a50c92954559b8e0';
export default node;
